'use client';

import { useSearchParams } from 'next/navigation';
import { useState, useEffect } from 'react';

import ProtectedRoute from '@/components/ProtectedRoute';
import Header from '@/components/Header';
import Bottom from '@/components/Bottom';
import ProfilePage from '@/components/profile/ProfilePage';
import ComingSoonPage from '@/components/ComingSoon';

// import MemberInfo from '@/components/MemberInfo';
// import HomePage from '@/components/home/HomePage';
// import PromotionPage from '@/components/promotion/PromotionPage';
// import NewsPage from '@/components/news/NewsPage';

declare global {
  interface Window {
    liff: any;
  }
}

function HomeContent() {
  const [activeTab, setActiveTab] = useState<string>('home');
  const searchParams = useSearchParams();
  const tab = searchParams.get('tab');
       
  useEffect(() => {
    (async () => {
      if(tab){
        setActiveTab(tab);
      }
    })()
  }, []);

  return (
    <div className="max-w-md mx-auto bg-gray-50 min-h-screen">
      <Header />
      {/* {activeTab !== 'profile' && <MemberInfo />} */}

      <div className="bg-white">
        {activeTab === 'home' && <ComingSoonPage />}
        {activeTab === 'promotions' && <ComingSoonPage />}
        {activeTab === 'news' && <ComingSoonPage />}

        {/* {activeTab === 'home' && <HomePage />}
        {activeTab === 'promotions' && <PromotionPage />}
        {activeTab === 'news' && <NewsPage />} */}

        {activeTab === 'profile' && <ProfilePage />}
      </div>
      <Bottom activeTab={activeTab} setActiveTab={setActiveTab}/>
    </div>
  );
}

export default function Home() {
  return (
    <ProtectedRoute>
      <HomeContent />
    </ProtectedRoute>
  );
}